// GENERATED FILE. DO NOT EDIT.
//
// The instants each schema on the public 'api' surface declares, generated from
// the mountayaapp/schemas contract (openapi/api.yaml): every property typed
// `format: date-time`, which the types beside this file declare as a Date. A response
// decodes a string to a Date only where one of these masks names it, so a field's type and
// its decoded value come from one declaration.
//
// Edit the spec in mountayaapp/schemas, not this file.

/** The instants in `AgentRun`. */
export const agentRunDates = { created_at: true } as const;

/** The instants in `CollabCollectionChangedEvent`. */
export const collabCollectionChangedEventDates = { occurred_at: true } as const;

/** The instants in `CollabItineraryChangedEvent`. */
export const collabItineraryChangedEventDates = { occurred_at: true } as const;

/** The instants in `CollabMember`. */
export const collabMemberDates = { connected_at: true } as const;

/** The instants in `CollabPresenceJoinEvent`. */
export const collabPresenceJoinEventDates = { connected_at: true } as const;

/** The instants in `CollabPresenceSnapshotEvent`. */
export const collabPresenceSnapshotEventDates = { members: [collabMemberDates] } as const;

/** The instants in `CollabSegmentChangedEvent`. */
export const collabSegmentChangedEventDates = { occurred_at: true } as const;

/** The instants in `CollabStreamEvent`. */
export const collabStreamEventDates = { connected_at: true, members: [collabMemberDates], occurred_at: true } as const;

/** The instants in `CollabWaypointChangedEvent`. */
export const collabWaypointChangedEventDates = { occurred_at: true } as const;

/** The instants in `CollabZoneChangedEvent`. */
export const collabZoneChangedEventDates = { occurred_at: true } as const;

/** The instants in `Collection`. */
export const collectionDates = { created_at: true, updated_at: true } as const;

/** The instants in `Invoice`. */
export const invoiceDates = { created_at: true } as const;

/** The instants in `Itinerary`. */
export const itineraryDates = { created_at: true, updated_at: true } as const;

/** The instants in `ItinerarySegment`. */
export const itinerarySegmentDates = { created_at: true, start_at: true } as const;

/** The instants in `ItinerarySegmentGroup`. */
export const itinerarySegmentGroupDates = { created_at: true } as const;

/** The instants in `WaypointTiming`. */
export const waypointTimingDates = { cutoff_at: true } as const;

/** The instants in `ItineraryWaypoint`. */
export const itineraryWaypointDates = { created_at: true, timing: waypointTimingDates } as const;

/** The instants in `ItineraryWithDetails`. */
export const itineraryWithDetailsDates = { created_at: true, groups: [itinerarySegmentGroupDates], published_at: true, segments: [itinerarySegmentDates], updated_at: true, waypoints: [itineraryWaypointDates] } as const;

/** The instants in `Membership`. */
export const membershipDates = { joined_at: true } as const;

/** The instants in `Organization`. */
export const organizationDates = { created_at: true, updated_at: true } as const;

/** The instants in `OrganizationInvitation`. */
export const organizationInvitationDates = { created_at: true, expires_at: true } as const;

/** The instants in `OrganizationMember`. */
export const organizationMemberDates = { joined_at: true } as const;

/** The instants in `SubscriptionDiscount`. */
export const subscriptionDiscountDates = { ends_at: true } as const;

/** The instants in `OrganizationSubscription`. */
export const organizationSubscriptionDates = { current_period_end_at: true, discount: subscriptionDiscountDates } as const;

/** The instants in `OrganizationSubscriptionSummary`. */
export const organizationSubscriptionSummaryDates = { api: organizationSubscriptionDates } as const;

/** The instants in `PublishableKey`. */
export const publishableKeyDates = { created_at: true, last_used_at: true, revoked_at: true } as const;

/** The instants in `SegmentCreateParams`. */
export const segmentCreateParamsDates = { start_at: true } as const;

/** The instants in `SegmentUpdateParams`. */
export const segmentUpdateParamsDates = { start_at: true } as const;

/** The instants in `Session`. */
export const sessionDates = { expires_at: true } as const;

/** The instants in `ShareLink`. */
export const shareLinkDates = { created_at: true } as const;

/** The instants in `UserInvitation`. */
export const userInvitationDates = { created_at: true, expires_at: true } as const;

/** The instants in `WaypointCreateParams`. */
export const waypointCreateParamsDates = { timing: waypointTimingDates } as const;

/** The instants in `WaypointUpdateParams`. */
export const waypointUpdateParamsDates = { timing: waypointTimingDates } as const;

/** The instants in `Zone`. */
export const zoneDates = { created_at: true, end_at: true, published_at: true, start_at: true, updated_at: true } as const;

/** The instants in `ZoneCreateParams`. */
export const zoneCreateParamsDates = { end_at: true, start_at: true } as const;

/** The instants in `ZoneUpdateParams`. */
export const zoneUpdateParamsDates = { end_at: true, start_at: true } as const;

/** The instants in each `CollabStreamEvent` event, by the `type` that names it. */
export const collabStreamEventDatesByType = { "collection.changed": collabCollectionChangedEventDates, "itinerary.changed": collabItineraryChangedEventDates, "presence.join": collabPresenceJoinEventDates, "presence.snapshot": collabPresenceSnapshotEventDates, "segment.changed": collabSegmentChangedEventDates, "waypoint.changed": collabWaypointChangedEventDates, "zone.changed": collabZoneChangedEventDates } as const;

/**
 * The instants in each schema that declares one, by the name the contract gives the schema.
 * Each value is that schema's mask above, the same object and never a copy. A schema with no
 * entry declares no instant, so nothing in its JSON decodes to a Date.
 */
export const restSchemaDates = { AgentRun: agentRunDates, CollabCollectionChangedEvent: collabCollectionChangedEventDates, CollabItineraryChangedEvent: collabItineraryChangedEventDates, CollabMember: collabMemberDates, CollabPresenceJoinEvent: collabPresenceJoinEventDates, CollabPresenceSnapshotEvent: collabPresenceSnapshotEventDates, CollabSegmentChangedEvent: collabSegmentChangedEventDates, CollabStreamEvent: collabStreamEventDates, CollabWaypointChangedEvent: collabWaypointChangedEventDates, CollabZoneChangedEvent: collabZoneChangedEventDates, Collection: collectionDates, Invoice: invoiceDates, Itinerary: itineraryDates, ItinerarySegment: itinerarySegmentDates, ItinerarySegmentGroup: itinerarySegmentGroupDates, ItineraryWaypoint: itineraryWaypointDates, ItineraryWithDetails: itineraryWithDetailsDates, Membership: membershipDates, Organization: organizationDates, OrganizationInvitation: organizationInvitationDates, OrganizationMember: organizationMemberDates, OrganizationSubscription: organizationSubscriptionDates, OrganizationSubscriptionSummary: organizationSubscriptionSummaryDates, PublishableKey: publishableKeyDates, SegmentCreateParams: segmentCreateParamsDates, SegmentUpdateParams: segmentUpdateParamsDates, Session: sessionDates, ShareLink: shareLinkDates, SubscriptionDiscount: subscriptionDiscountDates, UserInvitation: userInvitationDates, WaypointCreateParams: waypointCreateParamsDates, WaypointTiming: waypointTimingDates, WaypointUpdateParams: waypointUpdateParamsDates, Zone: zoneDates, ZoneCreateParams: zoneCreateParamsDates, ZoneUpdateParams: zoneUpdateParamsDates } as const;
